import React, { useEffect } from 'react'

import { Grid, TextField, Typography } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'
import useSupplierJourney from 'hooks/useSupplierJourney'

import * as service from 'service'
import helpers from 'helpers'

const ValidateEmailForm = ({ setIsLoading }) => {
  const { handleSubmit, control, errors } = useFormContext()
  const snackbar = useSnackbar()
  const {
    handleNext,
    companySupplierToken,
    accessToken,
    setAccessToken,
    user,
    setUser,
    company,
  } = useSupplierJourney()

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      const response =
        await service.supplierPortal.companySuppliers.validateByEmail({
          token: companySupplierToken,
          email: data?.email,
        })

      setUser(response?.data?.user)
      setAccessToken(response?.data?.accessToken)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao verificar seu email. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!user || !accessToken) return

    handleNext()
  }, [!!user, !!accessToken])

  return (
    <>
      <Grid item xs={12} md={8}>
        <Typography
          variant="h2"
          color="primary"
          style={{ textAlign: 'center' }}
        >
          Informe seu E-mail
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography
          variant="h4"
          style={{ fontWeight: 400, textAlign: 'center' }}
          color="primary"
        >
          Identificamos o seu cadastro na <strong>{company?.name}</strong>.
          Informe o seu e-mail para continuar.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <form id="form-register" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={8}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    label="E-mail"
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                  />
                }
                name="email"
                control={control}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  )
}

export default ValidateEmailForm
